import L from "leaflet";

type ShapeType = "circle" | "ring" | "diamond" | "square" | "triangle" | "cross" | "x";

const getShapePath = (shape: ShapeType, size: number, tileWidth: number, tileHeight: number) => {
  const cx = tileWidth / 2;
  const cy = tileHeight / 2;
  const s = size / 2;

  switch (shape) {
    case "circle":
      return `
        M ${cx},${cy - s}
        a ${s},${s} 0 1,0 0,${size}
        a ${s},${s} 0 1,0 0,-${size}
      `;
    case "ring":
      return `
        M ${cx},${cy - s}
        a ${s},${s} 0 1,0 0,${size}
        a ${s},${s} 0 1,0 0,-${size}
      `;
    case "diamond":
      return `
        M ${cx} ${cy - s}
        L ${cx + s} ${cy}
        L ${cx} ${cy + s}
        L ${cx - s} ${cy}
        Z
      `;
    case "square":
      return `
        M ${cx - s} ${cy - s}
        H ${cx + s}
        V ${cy + s}
        H ${cx - s}
        Z
      `;
    case "triangle":
      return `
        M ${cx} ${cy - s}
        L ${cx + s} ${cy + s}
        L ${cx - s} ${cy + s}
        Z
      `;
    case "cross": {
      const arm = size / 3;
      const half = size / 2;
      return `
        M ${cx - arm} ${cy - half}
        H ${cx + arm}
        V ${cy - arm}
        H ${cx + half}
        V ${cy + arm}
        H ${cx + arm}
        V ${cy + half}
        H ${cx - arm}
        V ${cy + arm}
        H ${cx - half}
        V ${cy - arm}
        H ${cx - arm}
        Z
      `;
    }
    case "x": {
      const d = s;
      const t = Math.max(1.5, size / 5);
      return `
        M ${cx - d} ${cy - d + t / 2}
        L ${cx - d + t / 2} ${cy - d}
        L ${cx} ${cy - t / 2}
        L ${cx + d - t / 2} ${cy - d}
        L ${cx + d} ${cy - d + t / 2}
        L ${cx + t / 2} ${cy}
        L ${cx + d} ${cy + d - t / 2}
        L ${cx + d - t / 2} ${cy + d}
        L ${cx} ${cy + t / 2}
        L ${cx - d + t / 2} ${cy + d}
        L ${cx - d} ${cy + d - t / 2}
        L ${cx - t / 2} ${cy}
        Z
      `;
    }
    default:
      return "";
  }
};

const ShapePatternClass = (L as any).Pattern.extend({
  options: {
    width: 24,
    height: 24,
    backgroundFillColor: "#ffffff",
    backgroundFillOpacity: 1,
    backgroundColor: "#ffffff",
    backgroundOpacity: 1,
    backgroundWeight: 0,

    shape: "circle",
    shapeSize: 10,
    shapeFill: true,
    shapeFillColor: "#000000",
    shapeFillOpacity: 1,
    shapeStroke: false,
    shapeColor: "#000000",
    shapeOpacity: 1,
    shapeWeight: 2,
  },

  _addShapes: function () {
    this._background = new L.PatternPath({
      stroke: this.options.backgroundWeight > 0,
      weight: this.options.backgroundWeight,
      color: this.options.backgroundColor,
      opacity: this.options.backgroundOpacity,
      fill: true,
      fillColor: this.options.backgroundFillColor,
      fillOpacity: this.options.backgroundFillOpacity,
    });

    this._shape = new L.PatternPath({
      stroke: this.options.shapeStroke,
      weight: this.options.shapeWeight,
      color: this.options.shapeColor,
      opacity: this.options.shapeOpacity,
      fill: this.options.shapeFill,
      fillColor: this.options.shapeFillColor,
      fillOpacity: this.options.shapeFillOpacity,
    });

    this.addShape(this._background);
    this.addShape(this._shape);
    this._update();
  },

  _update: function () {
    const w = this.options.width;
    const h = this.options.height;

    this._background.options.d = `M 0 0 H ${w} V ${h} H 0 Z`;
    this._shape.options.d = getShapePath(
      this.options.shape,
      this.options.shapeSize,
      w,
      h
    );
  },

  setStyle: L.Pattern.prototype.setStyle,
});

export default function ShapePattern(options: any) {
  return new ShapePatternClass(options);
}